import { Component, h } from 'preact'
import Row from './Row'
import Sorting from './Sorting'
import classNames from 'classnames'
import { Model, TableRow, Sort } from './types'
import PaginationComponent from '../ui-components/PaginationComponent'
import { subscribe } from '../../utils/globals'
import Checkbox from '../ui-components/Checkbox'
import TextButton from '../ui-components/TextButton'

export const defaultCellSize = 'm'

type Props = {
  model?: Model[],
  rows: TableRow[],
  rowId?: string,
  sort?: Sort,
  onSortChange?: (order: string) => void,
  narrow?: boolean,
  classes?: string[],
  style?: { [key: string]: any },
  withPagination?: {},
  actionElements?: JSX.Element,
  firstColumnSticky?: boolean,
  staticWidth?: boolean,
  withMultiSelect?: boolean,
  onSelectRow?: (rowId: number, checked: boolean) => void,
  onSelectAll?: () => void,
  onClearSelection?: () => void,
  selectedRows?: number[],
  allSelected?: boolean,
  entity?: string,
  bulkActions?: JSX.Element,
  isActionBarVisible?: boolean
}

type State = {
  isMenuOpen: boolean
}

class Table extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      isMenuOpen: true
    }
  }

  componentDidMount () {
    subscribe('control_sidebar_state', (payload) => this.setState({ isMenuOpen: payload.isOpen }))
  }

  render ({
    model,
    rows,
    rowId,
    sort,
    onSortChange,
    narrow,
    classes = [],
    style = {},
    withPagination,
    actionElements,
    firstColumnSticky = false,
    staticWidth = false,
    withMultiSelect,
    selectedRows,
    allSelected,
    onSelectRow,
    onSelectAll,
    onClearSelection,
    entity,
    bulkActions,
    isActionBarVisible = true
  }: Props, { isMenuOpen }: State) {
    const useObjectModel = model && model[0].hasOwnProperty('header')
    const showActionBar = isActionBarVisible && (withPagination || actionElements || (selectedRows && selectedRows.length > 0))
    return <div class='control-table'>
      { showActionBar && <div className='action-bar-wrapper'>
        { selectedRows && selectedRows.length > 0
          ? <div className='action-bar'>
            <div className='control-table__selected'>
              <div className='control-table__selected-count'>{selectedRows.length} {selectedRows.length > 1 ? entity : entity && entity.slice(0, -1)} selected</div>
              <TextButton class='control-table__clear-selection' onClick={onClearSelection}>Clear selection</TextButton>
            </div>
            { bulkActions && bulkActions }
          </div>
          : <div class='action-bar'>
            { actionElements && actionElements}
            { withPagination && <PaginationComponent {...withPagination} /> }
          </div>
        }
      </div> }
      <div class={classNames('table-wrapper', { 'with-action-bar': showActionBar })}
        style={staticWidth ? 'transition: none' : { width: `calc(100vw - ${isMenuOpen ? '376' : '152'}px)` }}>
        <table className={classNames({
          'narrow': narrow
        }, ...classes)} style={style}>
          <thead>
            <tr>
              { withMultiSelect && <th className='fixed-column-header table-header--multiselect'>
                <Checkbox
                  qaClasses='control-table__select_all'
                  onUpdate={() => onSelectAll && onSelectAll()}
                  checked={!!allSelected}
                />
              </th>}
              {
                model
                  ? Object.keys(model).map((key: any) => {
                    if (model[key].isHidden) {
                      return
                    }
                    return (<th className={`${model[key].size || defaultCellSize} ${firstColumnSticky && key === '0' ? 'fixed-column-header' : ''}`}>
                      {!model[key].hasOwnProperty('sorting') &&
                      <div className={`table-header-cell-${model[key].accessor}`}>
                        {useObjectModel ? model[key].header : model[key]}
                      </div>}
                      {model[key].hasOwnProperty('sorting') &&
                      <div className={`table-header-cell-${model[key].accessor} sortable`}
                        onClick={() =>
                          onSortChange &&
                             onSortChange(model[key].sorting || '')}>
                        {useObjectModel ? model[key].header : model[key]}
                        <Sorting
                          direction={sort?.direction}
                          isEnabled={sort?.order === model[key].sorting}
                        />
                      </div>}
                    </th>)
                  })
                  : rows[0].map((key: any) => <th className={`${key.size || defaultCellSize} ${firstColumnSticky && key === '0' ? 'fixed-column-header' : ''}`}>
                    <div className={`table-header-cell-${key.accessor} `}>{key.header}</div>
                  </th>)
              }
            </tr>
          </thead>
          <tbody>
            {
              Object.keys(rows).map((key: any) => {
                return (<Row
                  displayFirstColumnBold={firstColumnSticky}
                  id={rowId}
                  cells={rows[key]}
                  model={useObjectModel ? model : null}
                  isSelectable={withMultiSelect}
                  isSelected={selectedRows && !!rowId && selectedRows.includes(rows[key][rowId])}
                  onSelectRow={onSelectRow}
                />)
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  }
}

export default Table
